import { useCallback, useState } from 'react';
import { presetsApi } from '@api/presetsApi/presetsApi';
import { ScenarioEventsEntityName } from '@api/types/types';

export const useScenarioEventCopy = () => {
    const [loading, setLoading] = useState<boolean>(false);

    const copyScenarioEvent = useCallback(
        async ({
            eventId,
            entityName,
        }: {
            eventId: string;
            entityName: ScenarioEventsEntityName;
        }): Promise<any> => {
            const abortController = new AbortController();

            setLoading(true);

            const resp = await presetsApi.copyScenarioEvent({
                entityName,
                eventId,
                abortSignal: abortController.signal,
            });

            setLoading(false);

            return resp;
        },
        []
    );

    return {
        loading,
        copyScenarioEvent,
    };
};
